export default __webpack_public_path__ + "static/media/AppraisalWF3.9a4398ad.png";